import Typography from '@mui/material/Typography';
import { CollapsibleTable } from "../../components/CollapsibleTable";
import { MainContainer } from "../../components/MainContainerComp";
import ScrollIndicatorsComp from '../../components/ScrollIndicatorsComp/ScrollIndicatorsComp';
import { ISuspension, SuspensionsDataAutomation } from "./SuspensionsData";
import { tableHeaderStyles } from "./styled";
const cols = [{ title: 'From Date' }, { title: 'To Date' }, { title: 'Site' }, { title: 'Job/Commodity' }, { title: 'Description' }];

export const Suspensions = ({ data }: { data: ISuspension[] }) => (
  <MainContainer hasGreyBg>
    <Typography data-automation="restrictions-suspensions-title" sx={tableHeaderStyles}>Suspensions/Restrictions</Typography>
    <Typography 
      component={'div'} 
      variant='container' 
      data-automation="data-container"
    >
      <ScrollIndicatorsComp>
        <CollapsibleTable
          dataAutomation={SuspensionsDataAutomation}
          cols={cols}
          rows={data}
          isOneLevel={true}
        />
      </ScrollIndicatorsComp>
    </Typography>
  </MainContainer>
)